import React from "react";
import BooksContent from "./components/BooksContent/BooksContent";
import { IAdminFireBase } from "@/store/models/admin.models";
import { withAdmin } from "@/services/withAdmin";
import styles from "../ContentPage/VideoPage.module.scss";
import Layout from "@/components/Layout/Layout";

const BooksPageCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  return (
    <Layout admin={admin} pageNav={true}>
      <div className={styles.blocks}>
        <BooksContent />
      </div>
    </Layout>
  );
};

export const BooksPage = withAdmin(BooksPageCmp);
BooksPageCmp.displayName = "BooksPageCmp";

